import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { CreatorOfficeHoursData } from '../types'
import { Image } from '@dtx-company/shared-components/src/components/atoms/Image/index'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { prismicCachedImage } from '@app/prismic/src/utils'
import CTAButton from './CTAButton'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'
import React from 'react'

//sectionId is used for navigation
const CreatorOfficeHoursSection: React.FC<{
  data?: CreatorOfficeHoursData
  sectionId?: string
}> = ({ data, sectionId }) => {
  if (!data) return null
  return (
    <Box display="block" px={{ _: '33px', md: '60px' }} id={sectionId} data-testid={sectionId}>
      <Box
        display="grid"
        gridTemplateColumns={{ _: '1f', md: '33% auto' }}
        backgroundColor="primary.flowBlue"
        borderRadius="12px"
        maxWidth="1033px"
        mx="auto"
        py={{ _: '27px', md: '32px' }}
        px={{ _: '27px', md: '29px' }}
      >
        <Image
          src={prismicCachedImage(data.primary?.image?.url ?? '')}
          alt={data.primary?.image?.alt ?? 'Flowcode'}
          lazyLoad={true}
          gridArea={{ _: '2', md: '1' }}
        />
        <Box display="block" ml={{ _: 0, md: '21px' }} mb={{ _: '16px', md: '0' }}>
          <PrismicText
            richTextField={data.primary?.header}
            variant="display/large"
            color="primary.white"
            fontWeight="600"
            fontSize={{ _: '24px', md: '28px', lg: '32px' }}
            textAlign={{ _: 'center', md: 'left' }}
            lineHeight={{ _: '30px', lg: '40px' }}
          />
          <Spacer mb="24px" />
          <PrismicText
            richTextField={data.primary?.description}
            variant="body/medium"
            color="primary.white"
            textAlign={{ _: 'center', md: 'left' }}
            fontSize={{ _: '14px', md: '16px' }}
            style={{ whiteSpace: 'pre-wrap' }}
          />
          <Spacer mb="24px" />
          <PrismicText
            richTextField={data.primary?.address}
            variant="body/medium"
            color="primary.white"
            textAlign={{ _: 'center', md: 'left' }}
            fontSize={{ _: '14px', md: '16px' }}
            style={{ whiteSpace: 'pre-wrap' }}
          />
          <Spacer mb="24px" />
          <Box justifyContent={{ _: 'center', md: 'left' }}>
            <CTAButton
              data-heap-id="CreatorOfficeHoursSection_CTAButton"
              href={data.primary?.button_href?.url}
              label={data.primary?.button_label}
              variant={data.primary?.button_variant}
              backgroundColor="primary.white"
            />
          </Box>
        </Box>
      </Box>
      <Spacer mb={{ _: '32px', md: '56px', lg: '96px' }} />
    </Box>
  )
}

export default CreatorOfficeHoursSection
